import { Api } from '@user1st/api-client';
import { getCookie, removeCookie } from './cookieService';
import { COOKIES, PAGES } from '@/shared/consts';
import { AxiosRequestConfig } from 'axios';

const apiClient = new Api({
  baseURL: import.meta.env.VITE_API_CLIENT_BASE_URL,
  format: 'json',
  securityWorker: (): AxiosRequestConfig => {
    const result: AxiosRequestConfig = {
      headers: {},
    };

    const accessToken = getCookie(COOKIES.ACCESS_TOKEN);

    if (result.headers && accessToken) {
      result.headers.Authorization = `Bearer ${accessToken}`;
    }

    return result;
  },
});

apiClient.instance.interceptors.response.use((response) => {
  if (response.status === 401) {
    const accessToken = getCookie(COOKIES.ACCESS_TOKEN);
    if (accessToken) {
      removeCookie(COOKIES.ACCESS_TOKEN);
    }
    window.location.href = PAGES.BEFORE_LOGIN.SIGN_IN;
  }
  return response;
});

export { apiClient };
